import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AuthRepository } from 'app/state/auth.repository';
import { TenantsRepository } from 'app/state/tenants.repository';
import { User, UsersRepository } from 'app/state/users.repository';
import { UsersService } from 'app/api/services/users.service';
import { BlobStorageService } from 'app/shared/azure-blob/blob-storage.service';
import { Table } from 'primeng/table';
import { UserForListDto } from 'app/api/models/user/userForListDto';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
})
export class UsersListComponent implements OnInit {
  @Output() pageChange = new EventEmitter<number>();
  @Output() delete = new EventEmitter<string>();
  @Output() onUserSelection = new EventEmitter<UserForListDto[]>();

  @Input()
  set clearSelectedUsers(value: UserForListDto[]) {
    this.selectedUsers = value;
    this.clear();
  }
  @Input() innerWidth = 0;
  @Input() users: UserForListDto[] = [];
  @Input() isDeleteDisabled = true;

  @ViewChild('dt1') dt1!: Table;

  public filteredUsers: UserForListDto[] | null = null;
  public selectedUsers: UserForListDto[] = [];
  public actionConfirmation: User | null = null;
  public roles: any[];
  public userGroups: any[];
  public showUserGroups: boolean = false;
  selectedGroup: string | null = null;
  public selectedRole: string | null = null;
  public checked: boolean = false;
  constructor(
    public repo: UsersRepository,
    public tenantRepo: TenantsRepository,
    public service: UsersService,
    public auth: AuthRepository,
    public blobService: BlobStorageService,
    public generalDataRepo: GeneralDataRepository,
    private transloco: TranslocoService,
  ) {
    this.userGroups = [];
    this.roles = [
      { label: 'User', value: 'user' },
      { label: 'Admin', value: 'admin' },
      { label: 'Super', value: 'super' },
      { label: 'Partner', value: 'partner' },
    ];
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.users && this.users && this.users.length > 0) {
      this.updateUserGroups();

      const saved = localStorage.getItem('user-filters');

      if (saved && !this.search && !this.selectedGroupTemp) {
        this.checked = true;
        const parsed = JSON.parse(saved);
        this.search = parsed.search || '';
        this.selectedGroup = parsed.selectedGroup || null;
        this.selectedGroupTemp = this.selectedGroup;
        this.selectedRole = parsed.selectedRole || null;

        let tempUsers = [...this.users];

        if (this.selectedGroup) {
          if (this.selectedGroup === 'no-group') {
            tempUsers = tempUsers.filter(
              (u) => !u.groupsNames || u.groupsNames.length === 0,
            );
          } else {
            tempUsers = tempUsers.filter((u) =>
              u.groupsNames?.includes(this.selectedGroup!),
            );
          }
        }

        if (this.search) {
          tempUsers = tempUsers.filter(
            (user) =>
              user.fullName?.toLowerCase().trim().includes(this.search) ||
              user.email?.toLowerCase().trim().includes(this.search),
          );
        }

        this.filteredUsers = tempUsers;
        if (this.selectedRole && this.dt1) {
          this.dt1.filter(this.selectedRole, 'rolesNames', 'contains');
        }
      } else if (!this.search && !this.selectedGroupTemp) {
        this.filteredUsers = this.users;
      }
    }

    this.generalDataRepo.allGeneralData$.subscribe((x) => {
      this.showUserGroups = x.activeUserData.tenantSet;
    });
  }

  ngOnInit(): void {
    this.clear();
    //this.filteredUsers = this.users;
  }

  clear() {
    if (this.dt1) {
      this.dt1.clear();
    }
  }
  onRoleChange(value: string, filterCallback: any) {
    this.selectedRole = value;
    filterCallback(value);
    this.onCheckboxToggle();
  }
  handleActionClick(user: User) {
    this.delete.emit(user.id);
  }

  search = '';

  onGlobalFilter(table: Table, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    // table.filterGlobal(inputElement.value, 'contains');
    this.search = inputElement?.value?.toLowerCase()?.trim();

    this.filteredUsers = this.users.filter(
      (user) =>
        user.fullName
          .toLowerCase()
          .trim()
          .includes(inputElement.value.toLowerCase().trim()) ||
        user.email
          .toLowerCase()
          .trim()
          .includes(inputElement.value.toLowerCase().trim()),
    );
    this.onCheckboxToggle();
  }

  onCheckboxToggle() {
    if (this.checked) {
      const filterOptions = {
        search: this.search,
        selectedGroup: this.selectedGroup,
        selectedRole: this.selectedRole,
      };
      localStorage.setItem('user-filters', JSON.stringify(filterOptions));
    } else if (this.checked == false) {
      localStorage.removeItem('user-filters');
    }
  }

  getSeverity(status: any) {
    switch (status.toLowerCase()) {
      case 'user':
        return 'danger';

      case 'admin':
        return 'success';

      case 'super':
        return 'info';

      case 'partner':
        return 'warn';

      default:
        return 'info';
    }
  }

  getFieldValue(array: any[]) {
    if (array.length > 1) {
      return array[0] + '...';
    }
    return array[0];
  }

  updateUserGroups() {
    const groupsSet = new Set<string>();
    if (!this.users) return;
    this.users.forEach((user) => {
      if (user.groupsNames && Array.isArray(user.groupsNames)) {
        user.groupsNames.forEach((group) => {
          groupsSet.add(group);
        });
      }
    });

    this.userGroups = Array.from(groupsSet).map((group) => ({
      label: group,
      value: group,
    }));
  }
  get userGroupsWithNoGroup() {
    return [
      { label: this.transloco.translate('withoutGroup'), value: 'no-group' },
      ...this.userGroups,
    ];
  }

  selectedGroupTemp: string | null = null;
  filterByGroup(value: string) {
    this.selectedGroup = value;
    this.selectedGroupTemp = value;

    if (!value) {
      this.filteredUsers = [...this.users];
    } else if (value === 'no-group') {
      this.filteredUsers = this.users.filter(
        (u) => !u.groupsNames || u.groupsNames.length === 0,
      );
    } else {
      this.filteredUsers = this.users.filter((u) =>
        u.groupsNames?.includes(value),
      );
    }
    this.onCheckboxToggle();
  }

  onSelectionChange(event: any): void {
    this.onUserSelection.emit(this.selectedUsers);
  }
}
